import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import MenuFlyout from '@components/global/UtilityNav/MenuFlyout';
import IconWrapper from '@components/ui/Icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { FitSentimentFlyOut } from './FitSentimentFlyOut';

import styles from './ProductFitSentiment.module.scss';

export interface FitSentimentProps {
  fitSentimentData?: {
    fitSentiment: {
      percentageResults: {
        runsLarge: number;
        runsSmall: number;
        trueToSize: number;
      };
      total: number;
    };
    highestVotedSize?: string;
  };
}

export const ProductFitSentiment = ({
  fitSentimentData,
}: FitSentimentProps) => {
  const { t } = useTranslation('pdp');
  const [showPopover, setShowPopover] = useState(false);
  const togglePopover = () => setShowPopover(!showPopover);

  const [referenceElement, setReferenceElement] = useState<
    Element | null | undefined
  >(undefined);

  return fitSentimentData?.highestVotedSize ? (
    <>
      <div className={styles.fitSentimentContainer}>
        {t('product.fitSentiment.membersSay')}{' '}
        <button
          type="button"
          className={styles.button}
          onClick={togglePopover}
          ref={setReferenceElement}
        >
          <span className={styles.fitSentimentSize}>
            {t(`product.fitSentiment.${fitSentimentData?.highestVotedSize}`)}
          </span>{' '}
          <IconWrapper icon="info" height={16} classNames={styles.icon} />
        </button>
      </div>
      <OutsideClickHandler
        onOutsideClick={() => {
          setShowPopover(false);
        }}
      >
        <MenuFlyout
          showPopover={showPopover}
          referenceElement={referenceElement}
          placement="bottom-end"
        >
          <FitSentimentFlyOut
            total={fitSentimentData?.fitSentiment?.total}
            {...fitSentimentData?.fitSentiment?.percentageResults}
          />
        </MenuFlyout>
      </OutsideClickHandler>
    </>
  ) : null;
};

export default ProductFitSentiment;
